import React from 'react';
import '../css/AlertModal.css';
import EditableLabel from './EditableLabel';

interface AlertModalProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

const AlertModal: React.FC<AlertModalProps> = ({ open, title, message, onClose }) => {
  if (!open) return null;

  return (
    <div className="alert-modal-overlay" role="dialog" aria-modal="true">
      <div className="alert-modal-content">
        {title && (
          <div className="alert-modal-header">
            <h3 className="alert-modal-title">{title}</h3>
          </div>
        )}
        <div className={`alert-modal-body${!title ? ' no-header' : ''}`}>
          <p className="alert-modal-message">{message}</p>
        </div>
        <div className="alert-modal-footer">
          <button type="button" className="alert-modal-ok" onClick={onClose}>
            <EditableLabel labelKey="modals.alertCloseButton" defaultValue="閉じる" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
